export default {
  init($element) {

  },
  finalize($element) {
    function setFieldFunctions() {
      $element.find('.gfield').each(function() {
        const $this_ = $(this);

        $(this).find('input, textarea').on('focus', function() {
          $this_.addClass('fill');
        });

        $(this).find('input, textarea').on('blur', function() {
          if ($(this).val() == '') {
            $this_.removeClass('fill');
          }
        });

        $(this).find('textarea').attr('cols', 0);
      });

      // Custom checkbox
      $element.find('.gchoice').each(function() {
        if ($(this).find('.custom-checkbox').length == 0) {
          const $customCheckbox = $('<button type="button" class="custom-checkbox"></button>');
          $customCheckbox.prependTo($(this));
  
          const $checkbox = $(this).find('input[type="checkbox"]');
          $checkbox.hide();
  
          $customCheckbox.on('click', function() {
            $checkbox.prop('checked', !$checkbox.prop('checked'));
            $checkbox.trigger('change');
          });
  
          $checkbox.on('change', function() {
            if ($(this).prop('checked')) {
              $customCheckbox.addClass('checked');
            } else {
              $customCheckbox.removeClass('checked');
            }
          });
        }
      });
    }

    setFieldFunctions();

    // Custom submit
    $element.find('.submit-custom').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      $element.find('input[type="submit"]').trigger('click');
    });

    // const mutationCallback = function(mutationsList, observer) {
    //   setFieldFunctions();

    //   if ($element.find('form').length == 0) {

    //     // Success message
    //     $element.find('.content-form').addClass('d-none');
    //     $element.find('.content-success').removeClass('d-none');

    //     // Scroll up
    //     window.scrollTo(0, $element.offset().top - 250);

    //   } else {

    //     $element.find('.gfield').each(function() {
    //       if ($(this).find('input, textarea').val() != '') {
    //         $(this).addClass('fill');
    //       }
    //     });

    //   }
    // }

    // new MutationObserver(mutationCallback).observe($element.get()[0], {
    //   attributes: false,
    //   childList: true,
    //   subtree: true,
    // });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/flexible/contactForm.js